// removed by extract-text-webpack-plugin
module.exports = {"Input":"Input-module__Input__2pgvu","Label":"Input-module__Label__8xPmK","InputElement":"Input-module__InputElement__38cKR","Invalid":"Input-module__Invalid__3Cda3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Input/Input.module.css
// module id = 142
// module chunks = 0